import type { User } from '@/types/auth';
import { isSupervisor } from '@/utils/role';

import { hasTranscriptCrawlHospital } from './hospitals';

/** Supervisors see the crawl page only when assigned to White Oak or Shady Grove. Admins use the admin menu instead. */
export const canShowSupervisorMeetingTranscription = (user: User | null | undefined): boolean =>
    isSupervisor(user) && hasTranscriptCrawlHospital(user?.hospitals);
